import { LogIn } from "lucide-react";
import { useDispatch } from "react-redux";
import { Button, Input, notification, Form } from 'antd';

// Components
import { axiosPost } from "../services/http.services";
import { API_LOGIN } from "../api/api";
import { loginUser } from "../store/actions/authActions";

const LoginPage = () => {
	const dispatch = useDispatch();

	const [LoginForm] = Form.useForm();

	const openNotification = (type, message, description) => {
		notification[type]({
			message,
			description,
			placement: "bottomRight",
			duration: 2
		});
	};

	const handleSubmit = async (values) => {
		const { email, password } = values;  // destructure values
		try {
			const res = await axiosPost(API_LOGIN, { email, password });
			const data = res?.data
			openNotification("success", "Login Successful", "You are now logged in!");
			setTimeout(() => {
				loginUser(data, dispatch)
			}, 1000);
		} catch (error) {
			console.log(error);
			openNotification("error", "Login Failed", "Invalid username or password!");
		}
	};

	return (
		<div className="flex items-center justify-center bg-background" style={{ marginTop: 100 }}>
			<div className="w-full max-w-md bg-card rounded-xl shadow-md border border-border px-8 pb-3 pt-0">
				<Form
					form={LoginForm}
					onFinish={handleSubmit} // Connect form submission with the handleSubmit function
					labelCol={{ span: 5 }}
					style={{ marginTop: 25 }}
					className="flex flex-col gap-6"
				>
					<div className="flex flex-col items-center gap-2 text-center">
						<h1 className="text-2xl font-bold">
							Login
						</h1>
						<p className="text-balance text-sm text-muted-foreground">
							Enter your username and password to login
						</p>
					</div>

					<div className="grid">
						<h2 class="text-md font-semibold text-gray-800 ml-2">Username</h2>

						{/* Email Field */}
						<Form.Item name="email"
							rules={[
								{ required: true, message: 'Please fill all fields.' },
							]}>
							<Input placeholder="Enter Username" />
						</Form.Item>

						{/* Password Field */}
						<h2 class="text-md font-semibold text-gray-800 ml-2">Password</h2>
						<Form.Item name="password"
							rules={[
								{ required: true, message: 'Please fill all fields.' },
							]}>
							<Input.Password placeholder="Enter Password" />
						</Form.Item>

						{/* Submit Button */}
						<Form.Item>
							<Button type="primary" htmlType="submit" className="w-full mt-2">
								<LogIn className="h-4 w-4" />
								Login
							</Button>
						</Form.Item>
					</div>
				</Form>
			</div>
		</div>
	);
};

export default LoginPage;
